import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  morePath?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  morePath,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <div className="flex items-center gap-3">
          <span className="w-1 h-5 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
            {title}
          </h2>
        </div>
        {subtitle && (
          <p className="mt-2 text-sm text-foreground-500 pl-4">{subtitle}</p>
        )}
      </div>
      {morePath && (
        <Link
          to={morePath}
          className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}